import lazyWithRetry from 'services/lazyWithRetry';
import { Features, Roles } from 'typings/enums';
import { RouteCollection } from 'typings/shared';

const ListPage = lazyWithRetry(() => import('./List'));
const AddPage = lazyWithRetry(() => import('./Add'));
const ShowPage = lazyWithRetry(() => import('./Show'));
const EditPage = lazyWithRetry(() => import('./Edit'));

export const paths = {
    LIST: '/manager',
    ADD: '/manager/add',
    SHOW: '/manager/:id/show',
    EDIT: '/manager/:id/edit',
};

export const routes: RouteCollection = {
    list: {
        exact: true,
        path: paths.LIST,
        component: ListPage,
        roles: [Roles.BASE_USER],
        features: [Features.RENTAL_AGENCY],
    },
    add: {
        exact: true,
        path: paths.ADD,
        component: AddPage,
        roles: [Roles.TRADER],
        features: [Features.RENTAL_AGENCY],
    },
    show: {
        exact: true,
        path: paths.SHOW,
        component: ShowPage,
        roles: [Roles.BASE_USER],
        features: [Features.RENTAL_AGENCY],
    },
    edit: {
        exact: true,
        path: paths.EDIT,
        component: EditPage,
        roles: [Roles.TRADER],
        features: [Features.RENTAL_AGENCY],
    },
};
